export default __webpack_public_path__ + "static/media/Hitachi-Vantara.82ea6b4a.jpg";